<template>
  <el-pagination
    v-model:current-page="page"
    v-model:page-size="getList_params.MaxResultCount"
    :page-sizes="[10, 20, 30, 40 ,50 ,100,500,1000]"
    background
    layout="total, sizes, prev, pager, next, jumper"
    :total="total"
    @size-change="handleSizeChange"
    style="margin-top: 10px"
  />
</template>

<script setup>
import { computed, reactive, watch } from "vue";
const props = defineProps({
  total: {
    type: Number,
    required: true,
  },
  params: {},
});
const emits = defineEmits(["getList"]);

const getList_params = reactive({
  SkipCount: 0,
  MaxResultCount: 10,
});

const call = () => {
  Object.assign(getList_params, props.params);

  emits("getList", getList_params);
};

watch(
  () => props.params,
  (val) => {
    call();
  },
  { deep: true, immediate: true }
);

const page = computed({
  get() {
    return (
      Math.floor(getList_params.SkipCount / getList_params.MaxResultCount) + 1
    );
  },
  set(val) {
    getList_params.SkipCount = (val - 1) * getList_params.MaxResultCount;
    call();
  },
});

const handleSizeChange = (val) => {
  getList_params.MaxResultCount = val;
  call();
};

defineExpose({
  getList_params,
});
</script>

<style  scoped lang="scss">
:deep() {
  --el-fill-color-blank: #105da5;
  --el-text-color-regular: #6fcaf7;
  --el-border-color: transparent;
  --el-border-color-hover: transparent;

  --el-color-primary: #70ABFE;
  --el-disabled-bg-color: #105da5;
  --el-pagination-button-bg-color: #105da5;
  --el-pagination-button-color: #6fcaf7;
  --el-text-color-placeholder: #6fcaf7;
  
  .btn-prev,.btn-next{
    .el-icon{
      font-size: 16px;
    }
  }
}
</style>
